<script setup lang="ts">
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import SearchableSelectMenu from '@/components/ui/searchable-select-menu/SearchableSelectMenu.vue';

withDefaults(defineProps<{
    id: string;
    modelValue: string;
    options: ReadonlyArray<{ value: string; label: string; description?: string }>;
    label?: string;
    placeholder?: string;
    searchPlaceholder?: string;
    clearLabel?: string;
    emptyText?: string;
    loading?: boolean;
    loadingLabel?: string;
    disabled?: boolean;
    refreshable?: boolean;
    refreshLabel?: string;
    refreshHint?: string;
    editHref?: string;
    editLabel?: string;
}>(), {
    label: 'Template', placeholder: 'Select a template', searchPlaceholder: 'Search templates…',
    clearLabel: 'No template', emptyText: 'No templates found.', loading: false, loadingLabel: 'Loading templates…',
    disabled: false, refreshable: true, refreshLabel: 'Refresh template', refreshHint: '', editHref: '', editLabel: 'Edit template',
});
const emit = defineEmits<{ 'update:modelValue': [value: string]; refresh: [] }>();
</script>

<template>
    <div class="space-y-2">
        <Label :for="id"><slot name="label">{{ label }}</slot></Label>
        <SearchableSelectMenu :id="id" :model-value="modelValue" :options="options" :placeholder="loading ? loadingLabel : placeholder" :search-placeholder="searchPlaceholder" :empty-state-label="emptyText" :disabled="disabled || loading" allow-clear :clear-label="clearLabel" show-all-by-default variant="form" @update:model-value="emit('update:modelValue', $event)" />
        <div v-if="refreshable && modelValue" class="flex flex-wrap items-center gap-2">
            <Button type="button" variant="ghost" size="sm" :disabled="disabled || loading" @click="emit('refresh')">{{ loading ? loadingLabel : refreshLabel }}</Button>
            <span v-if="refreshHint" class="text-xs text-muted-foreground">{{ refreshHint }}</span>
            <a v-if="editHref" :href="editHref" target="_blank" rel="noopener noreferrer" class="text-xs text-primary underline">{{ editLabel }}</a>
            <slot name="actions" />
        </div>
        <slot name="helper" />
    </div>
</template>
